export default "__VITE_ASSET__D9uCnsf4__"